module.exports = __webpack_public_path__ + "static/media/capital-wallet-trader-registration.8af957b.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/website/video/capital-wallet-trader-registration.mp4
// module id = B3w7
// module chunks = 1